module.exports = __webpack_public_path__ + "img/footer_logo.c090b343.png";